<template>
  <div class="replacementmonthlystatistics__report__view">    
    <div class="reports__subheader">
      <submit-panel @submit="createClick" text="Opret gruppe">
      </submit-panel>
    </div>
    <b-table :data="groupsForUser"
             :loading="loading"
             @click="editClick"
             hoverable>

      <b-table-column field="groupName"
                      label="Navn"
                      v-slot="props">
        {{ props.row.groupName }}
      </b-table-column>
      
      <b-table-column field="region"
                      label="Region"
                      v-slot="props">
        {{ props.row.region }}
      </b-table-column>
      
      <b-table-column>
        <span>
          <b-icon pack="fas"
                  icon="angle-right"></b-icon>
        </span>
        <template v-slot:header>
        </template>
      </b-table-column>
    </b-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ApiState from "../../enums/APISTATE";
import moment, { ISO_8601 } from 'moment';
import SubmitPanel from '@/components/report/SubmitPanel.vue';

export default {
  name: "groups-for-user-view",
  components: {SubmitPanel},
  data: () => ({  }),
  async mounted() {
      console.log(this.currentUser);
    await this.getGroupsForUser(this.currentUser.id);
  },
  computed: {
    ...mapGetters("groupStore", ["groupsForUserApiState", "groupsForUser"]),
    ...mapGetters(["currentUser"]),
     loading() {
      return this.groupsForUserApiState !== ApiState.LOADED;
    },
  },
  methods: {
    ...mapActions("groupStore", ["getGroupsForUser"]),
    dateFormat(arg) {
        return moment(arg).format('YYYY-MM-DD');
    },
    editClick(row) {
      this.$router.push(`/configuration-user/my-groups/${row.groupId}/group`);
    },
    createClick() {
      this.$router.push("/configuration-user/my-groups/new");
    },
  },
};
</script>

<style lang="scss" scoped>
.users-view {
  .register-user {
    cursor: pointer;
    width: 100%;
  }
}

.table td {
  text-align: left !important;
}
</style>
